import * as React from 'react';
import Styled, { keyframes } from 'styled-components';

import { Headline } from '../../Typography';

import { StatusModalHeadlineText } from './StatusModalHeadlineText';

const textFade = keyframes`
  0% { opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { opacity: 0; }
`;

interface IAnimatedTextProps {
  timePerMessage: number;
}

export const StatusModalAnimatedText = Styled.span<IAnimatedTextProps>`
  opacity: 0;
  animation: ${textFade} ${props => props.timePerMessage}s linear;
  animation-iteration-count: infinite;
`;

export const StatusModalProgress = Styled.div`
  position: relative;
  width: 100%;
  height: 0.75em;
  overflow: hidden;
  background-color: ${({ theme: { progress } }) => progress.colorBarBackground};
  border-radius: ${({ theme: { modal } }) => modal.borderRadius};

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 1px solid ${({ theme: { progress } }) => progress.colorBarBorder};
    border-radius: ${({ theme: { modal } }) => modal.borderRadius};
  }
`;

const slowFillAnimation = keyframes`
  0% { width: 0; }
  5% { width: 50%; }
  10% { width: 75%; }
  45% { width: 90%; }
  100% { width: 100%; }
`;

export const StatusModalProgressBar = Styled.div`
  background-color: ${({ theme: { progress } }) => progress.colorBar};
  animation: ${slowFillAnimation} 60s linear;
  height: 100%;
  transition: 0.25s;
  border-radius: ${({ theme: { modal } }) => `${modal.borderRadius} 0 0 ${modal.borderRadius}`};
  position: absolute;
  width: 100%;
`;

const quickFillAnimation = keyframes`
  0% { width: 0; }
  100% { width: 100%; }
`;

export const StatusModalFastAnimatedProgressBar = Styled(StatusModalProgressBar)`
  animation: ${quickFillAnimation} 2.5s linear;
  animation-direction: forwards;
  width: 100%;
`;

const StyledHeadline = Styled(Headline)`
  margin-bottom: 0.5em;
`;

interface IStatusHeadlineProps {
  headline: string;
}

export const StatusModalHeadline: React.FunctionComponent<IStatusHeadlineProps & React.HTMLAttributes<HTMLElement>> =
  ({ headline, children }) => (
    <StatusModalHeadlineText>
      <StyledHeadline scale='medium' as='h2'>{headline}</StyledHeadline>
      {children}
    </StatusModalHeadlineText>
  );
